import { alertActions } from "../config/action-config";

const initial = { show: false, severity: "", message: "" };

const alertReducer = (state = initial, action) => {
  const { type, severity, message, onClose } = action;
  switch (type) {
    case alertActions.ALERT_SHOW:
      return { show: true, severity, message, onClose };
    case alertActions.ALERT_HIDE:
      return { ...state, show: false, message: "" };
    default:
      return state;
  }
};

export default alertReducer;
